import { useEffect } from "react";

export function useViewportHeight() {
    useEffect(() => {
        const setRealVH = () => {
            const vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty("--vh", `${vh}px`);
        };

        setRealVH();

        window.addEventListener("resize", setRealVH);
        return () => window.removeEventListener("resize", setRealVH);
    }, []);
}